import React from 'react';
import { string } from 'prop-types';
import { ApolloProvider } from '@apollo/client';
import CreateApolloClient from './GraphQL/Client';
import Layout from './Layout';

const client = CreateApolloClient();

const App = ({ service }) => (
  <ApolloProvider client={client}>
    <Layout service={service} />
  </ApolloProvider>
);

App.propTypes = {
  service: string,
};

App.defaultProps = {
  service: 'outlook',
};

export default App;
